import { GlobalState } from "../../state/GlobalState";

/**
 * Selects a single trace from the store.
 */
export default function traceSelector(state: GlobalState, traceId: string) {
    return state.traces.idToEntityMap.get(traceId);
}
